<template>
  <div class="message box-info-dashboard" :class="`is-${type}`">
    <div class="message-body">
      <div class="media">
        <div class="media-left">
          <div v-if="icon" class="m-icon-wrp" :class="type">
            <span class="icon"><i :class="icon ? icon : ''"></i></span>
          </div>
        </div>
        <div class="media-content has-text-right">
          <p>{{title}}</p>
          <p class="subtitle is-4">{{content}}</p>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'annotation';

  @Component
  export default class BoxInfoDashboard extends Vue {

    @Prop({type: String, default: ''})
    public title: string;

    @Prop({type: String, default: ''})
    public content: string;

    @Prop({type: String, default: ''})
    public icon: string;

    @Prop({type: String, default: 'info'})
    public type: string;
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .box-info-dashboard {
    @include b_sh_def(true);
    .m-icon-wrp span {
      color: inherit;
    }

    .m-icon-wrp.info {
      background-color: rgba($info, 0.25);
      color: $info;
    }

    .m-icon-wrp.danger {
      background-color: rgba($danger, 0.25);
      color: $danger;
    }

    .m-icon-wrp.link {
      background-color: rgba($link, 0.25);
      color: $link;
    }

    .m-icon-wrp.primary {
      background-color: rgba($primary, 0.25);
      color: $primary;
    }

    .m-icon-wrp.dark {
      background-color: rgba($dark, 0.25);
      color: $dark;
    }

    .m-icon-wrp.warning {
      background-color: rgba($warning, 0.25);
      color: $warning;
    }

    .m-icon-wrp.success {
      background-color: rgba($success, 0.25);
      color: $success;
    }

    .media {
      .media-left {
        margin-top: -2.5rem;
        span.icon {
          height: 100%;
          width: 100%;
        }
      }
      .m-icon-wrp {
        width: 65px;
        height: 65px;
        border-radius: 6px;
      }

      .media-content > p:first-child {
        margin-bottom: .3rem;
      }
    }
  }
</style>